export const GetImage = (type: string) => {
  switch (type) {
    case 'buildandburn':
      return '/assets/buildandburn.png'
    case 'bodypump':
      return '/assets/bodypump.png'
    case 'circletraining':
      return '/assets/circletraining.png'
    case 'gym':
      return '/assets/gym.png'
    case 'opengym':
      return '/assets/opengym.png'
    case 'running':
      return '/assets/running.png'
    case 'spinning':
      return '/assets/spinning.png'
    default:
      return '/assets/circletraining.png'
  }
}